import React, { useState, Fragment, useRef, useEffect } from "react";
import HoverIconButton from "components/HoverIconButton";
import { FieldArray, useFormikContext } from "formik";
import { getFieldPath } from "utils/form";
import get from "lodash/get";
import CheckoutPricePicker from "components/CheckoutPricePicker";
import classnames from "classnames";
import SlimCTA from "components/SlimCTA";
import { getNewPriceInLatestConfig } from "utils/constants/price";

const NO_MODELS_SUBHEADER = "Add a price to this product.";

const CheckoutPricePickers = ({ rootPath, name, copy = {} }) => {
  const { values } = useFormikContext();
  const [showOnMountKey, setShowOnMountKey] = useState();
  const fieldName = getFieldPath(rootPath, name);
  const firstNameRef = useRef(null);
  useEffect(() => {
    firstNameRef.current && firstNameRef.current.focus();
  }, []);

  const models = get(values, fieldName);
  const hasModels = models && models.length > 0;
  const noModelsCopy = get(copy, "empty", NO_MODELS_SUBHEADER);

  return (
    <Fragment>
      <FieldArray
        name={fieldName}
        render={(arrayHelpers) => {
          const addPrice = () => {
            const newPrice = getNewPriceInLatestConfig({ models });
            setShowOnMountKey(newPrice.key);
            arrayHelpers.push(newPrice);
          };

          const noModelsCTAProps = {
            subheader: noModelsCopy,
            actions: [
              {
                copy: "Add",
                onClick: addPrice
              }
            ]
          };

          return hasModels ? (
            <ul className="list ma0 pa0 w-100 h-100">
              {models.map((model, modelIx) => {
                const modelName = `${fieldName}[${modelIx}]`;

                const pickerProps = {
                  name: modelName,
                  modelIx: modelIx,
                  arrayHelpers: arrayHelpers,
                  showOnMount: showOnMountKey && showOnMountKey === model.key
                };
                if (!modelIx) {
                  pickerProps.innerNameRef = firstNameRef;
                }

                /**
                 * In create mode we append a placeholder key to the new models
                 * In edit mode we use the chosen price
                 */
                const keyName = model.key || model.id;
                return (
                  <div
                    key={keyName}
                    className={classnames("w-100", {
                      pt3: modelIx
                    })}
                  >
                    <CheckoutPricePicker {...pickerProps} />
                  </div>
                );
              })}
              <div className="flex flex-row justify-start pt3">
                <div className="flex flex-row w-100 justify-end items-center">
                  <div className="fw5 f6 pr2">{`Add price`}</div>
                  <HoverIconButton
                    type="add"
                    tooltip="Add"
                    onClick={addPrice}
                  />
                </div>
              </div>
            </ul>
          ) : (
            <SlimCTA {...noModelsCTAProps} />
          );
        }}
      />
    </Fragment>
  );
};

export default CheckoutPricePickers;
